import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'

import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'

import { Box, Button, Columns } from '@domain-group/suit-theme'

import PageHeader from '@components/PageHeader'

import generateTabBarItems from '../../utils/generateTabBarItems'

const PageLayout = (props) => {
  const { activeTabBarItemKey, children, entityPayload } = props

  const {
    orderBundle,
    urls: { orderBundlesIndexUrl },
  } = entityPayload

  const { redirect } = parsePermittedQueryParams(getQueryParamsFromHash(), ['redirect'])

  return (
    <>
      <Helmet>
        <title>Edit Order Bundle | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button
            as="a"
            buttonStyle="secondaryUtility"
            href={redirect || orderBundlesIndexUrl}
            size="medium"
            width="auto"
          >
            Back
          </Button>
        )}
        activeTabBarItemKey={activeTabBarItemKey || 'details'}
        tabBarItems={generateTabBarItems(orderBundle)}
        title="Edit Order Bundle"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          {children}
        </Columns>
      </Box>
    </>
  )
}

PageLayout.propTypes = {
  activeTabBarItemKey: PropTypes.string,
  children: PropTypes.node.isRequired,
  entityPayload: PropTypes.shape({
    orderBundle: PropTypes.object.isRequired,
    urls: PropTypes.shape({
      orderBundlesIndexUrl: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
}

export default PageLayout
